import { toast } from "sonner";
import { t } from "i18next";
import type { Feature } from "@/types/features.types";
import { useGetFeatures } from "@/api/get-features/use-get-features";

export const useFeatures = () => {
	const { data: features, isLoading, error } = useGetFeatures();

	if (error) {
		toast.error(error.message || t("Failed to load features"));
	}

	function hasFeature(feature: Feature) {
		return features?.[feature] ?? false;
	}

	return {
		features,
		hasFeature,
		isLoading,
	};
};
